import '@angular/localize/init';
export * from './lib/feature-tax-sba-list.module';

export * from './lib/tax-sba-list/feature-tax-sba-list.component';
